module.exports = __webpack_public_path__ + "media/images/home-page/1-3-bc4f6ecbb4c4607a2ae733d42156f95c.png";